import React, { useEffect, useRef, useState } from "react";
import { usePollsContext } from "../../context/PollsContext";
import { useParams } from "react-router-dom";
import Theme from "../EventPage/Theme";
import Result from "../../components/Polls/Result";
import './style.scss';
import Hint from "../../components/Hint";
import { usePlayerContext } from "../../context/PlayerContext";
import { fullscreenClose, fullscreenOpen, isFullscreen } from "../../components/Player/FullScreen";

const getScaledFont = (poll) => {
    let scale = 1;

    // if (Array.isArray(poll?.answer) && poll.answer.length < 13 && poll.type !== "open") {
    //     scale = 14 / poll.answer.length;
    //     scale = scale > 3 ? 3 : scale;
    // }

    return scale + "em";
}

export default ({ }) => {
    const ref = useRef(null);
    const { pollID } = useParams();
    const { allPolls } = usePollsContext();
    const { tabletView } = usePlayerContext();
    const [poll, setPoll] = useState(null);
    const [zoomed, setZoomed] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(130);
    const [pollResultWidth, setPollResultWidth] = useState(72);

    useEffect(() => {
        setPoll(allPolls?.find(({ id }) => String(id) === String(pollID)));
    }, [allPolls, pollID])

    const onPlus = () => {
        setZoomLevel(prevZoomLevel => {
            if (prevZoomLevel < 60) {
                return prevZoomLevel + 2;
            }

            return prevZoomLevel + 10;
        });
        setPollResultWidth(prevWidth => {
            if (prevWidth <= 56) {
                return prevWidth - 2;
            }

            return prevWidth - 8;
        })
    }

    const onMinus = () => {
        setZoomLevel(prevZoomLevel => {
            if (prevZoomLevel <= 60) {
                return prevZoomLevel - 2;
            }

            return prevZoomLevel - 10;
        });
        setPollResultWidth(prevWidth => {
            if (prevWidth < 56) {
                return prevWidth + 2;
            }

           return prevWidth + 8;
        });
    }

    useEffect(() => {
        const keyDownListener = (e) => {
            if (e.key === 'ArrowUp') {
                onPlus();
                setZoomed(true);
            } else if (e.key === 'ArrowDown') {
                onMinus();
                setZoomed(true);
            }

            if (e.code === 'KeyF' && !isFullscreen()) {
                fullscreenOpen(ref.current);
            }
            if (e.code === 'Escape' && isFullscreen()) {
                fullscreenClose();
            }
        }

        window.addEventListener('keydown', keyDownListener);

        return () => {
            window.removeEventListener('keydown', keyDownListener);
        }

    }, []);

    if (!poll) return null;

    const pollResultStyle = {
        fontSize: getScaledFont(poll),
        zoom: zoomLevel / 100,
        width: `${pollResultWidth}vw`,
    }

    return (
        <div ref={ref}>
            <Theme />
            <div className="poll-result-page scrollable">
                {poll.resultPageBackgroundImageUrl && <>
                    <img className="bg-image full-width-bg" alt="" src={poll.resultPageBackgroundImageUrl} />
                    <img className="bg-image main-bg" alt="" src={poll.resultPageBackgroundImageUrl} />
                </>
                }
                <div className={`poll-result-page-content ${poll.type} ${!poll.backgroundEnabled ? "disable-background" : ""}`} style={pollResultStyle}>
                    <Result poll={poll} force headerHidden={poll.headerHidden} />
                </div>
                {!tabletView && <Hint type="fullscreen" animationType="hiding" />}
                {(!tabletView && !zoomed && poll.type !== 'open') && <Hint type="zoom" animationType="hiding" />}
            </div>
        </div>
    )
}